var map = {
	"./App": 5826,
	"./App.vue": 5826,
	"./assets/website-01/conf": 2341,
	"./assets/website-01/conf.json": 2341,
	"./assets/website-01/data": 2751,
	"./assets/website-01/data.json": 2751,
	"./assets/website-01/favicon.png": 6482,
	"./assets/website-01/images/anillo-00.webp": 8777,
	"./assets/website-01/images/aretes-calcita-00.webp": 1002,
	"./assets/website-01/images/aretes-colibri-00.webp": 4234,
	"./assets/website-01/images/aretes-zorro-00.webp": 3081,
	"./assets/website-01/images/background-00.webp": 9699,
	"./assets/website-01/images/balaca-00.webp": 8963,
	"./assets/website-01/images/banner-03.webp": 6437,
	"./assets/website-01/images/bolso-00.webp": 4725,
	"./assets/website-01/images/buhos-02.webp": 1616,
	"./assets/website-01/images/candonga-imperial-00.webp": 8779,
	"./assets/website-01/images/collar-arbol-01.webp": 6368,
	"./assets/website-01/images/collar-arbol-02.webp": 6417,
	"./assets/website-01/images/collar-piedra-lujo-00.webp": 1061,
	"./assets/website-01/images/ear-cuff-00.webp": 7093,
	"./assets/website-01/images/gargantilla-01.webp": 86,
	"./assets/website-01/images/gatita-rosa-00.webp": 8130,
	"./assets/website-01/images/juego-anillos-aretes-03.webp": 6183,
	"./assets/website-01/images/juego-coquette-00.webp": 4638,
	"./assets/website-01/images/juego-frida-00.webp": 7313,
	"./assets/website-01/images/juego-gatita-rosa.webp": 4955,
	"./assets/website-01/images/juego-guacamaya-blue-00.webp": 7258,
	"./assets/website-01/images/juego-nido-01.webp": 2699,
	"./assets/website-01/images/juego-pinguina-00.webp": 2140,
	"./assets/website-01/images/juego-rosas-01.webp": 4198,
	"./assets/website-01/images/juego-rosas-02.webp": 8658,
	"./assets/website-01/images/lasso-001.webp": 218,
	"./assets/website-01/images/llavero-01.webp": 8662,
	"./assets/website-01/images/logo.webp": 8097,
	"./assets/website-01/images/lydhie-mission-01.webp": 8406,
	"./assets/website-01/images/manilla-00.webp": 6111,
	"./assets/website-01/images/pectoral-01.webp": 4520,
	"./assets/website-01/images/pinza-cabello-00.webp": 4703,
	"./assets/website-01/images/pulsera-anillo-escarcha-00.webp": 636,
	"./assets/website-01/images/pulsera-perla-rio-01.webp": 534,
	"./assets/website-01/images/pulsera-piedra-blanca-00.webp": 6752,
	"./assets/website-01/images/pulsera-piedra-rio-00.webp": 3036,
	"./assets/website-01/images/sombrero-00.webp": 6746,
	"./components/FooterComponent": 6794,
	"./components/FooterComponent.vue": 6794,
	"./components/HtmlComponent": 9101,
	"./components/HtmlComponent.vue": 9101,
	"./components/ItemComponent": 8113,
	"./components/ItemComponent.vue": 8113,
	"./components/ItemImageTapeComponent": 9297,
	"./components/ItemImageTapeComponent.vue": 9297,
	"./components/ItemImagesComponent": 9162,
	"./components/ItemImagesComponent.vue": 9162,
	"./components/ItemListComponent": 4905,
	"./components/ItemListComponent.vue": 4905,
	"./components/ItemOnlyTextComponent": 5041,
	"./components/ItemOnlyTextComponent.vue": 5041,
	"./components/ItemPricingComponent": 4761,
	"./components/ItemPricingComponent.vue": 4761,
	"./components/ItemSectionComponent": 1793,
	"./components/ItemSectionComponent.vue": 1793,
	"./components/ItemSwiperComponent": 6642,
	"./components/ItemSwiperComponent.vue": 6642,
	"./components/ListComponent": 3838,
	"./components/ListComponent.vue": 3838,
	"./components/LoadImageComponent": 4478,
	"./components/LoadImageComponent.vue": 4478,
	"./components/MainBannerComponent": 9690,
	"./components/MainBannerComponent.vue": 9690,
	"./components/NavbarComponent": 9564,
	"./components/NavbarComponent.vue": 9564,
	"./components/PopupComponent": 2019,
	"./components/PopupComponent.vue": 2019,
	"./main": 866,
	"./main.js": 866,
	"./services/DataWebsite": 5467,
	"./services/DataWebsite.js": 5467,
	"./services/getCurrentDateTime": 2800,
	"./services/getCurrentDateTime.js": 2800,
	"./services/googleSchemeGenerator": 4241,
	"./services/googleSchemeGenerator.js": 4241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;